module.exports = __webpack_public_path__ + "assets/img/kv-ad44fdd4.jpg";